import { FormControl, InputLabel, Select, MenuItem, Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import './dynamicfilter.css'

const DynamicFilter = ({filters, values, onChange }) => {
  const [filterType, setFilterType] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  const handleFilterTypeChange = (event) => {
    const newFilterType = event.target.value;
    setFilterType(newFilterType);
    setSelectedOption(null);
    onChange(newFilterType, null);
  };

  const handleOptionChange = (event, newValue) => {
    setSelectedOption(newValue);
    onChange(filterType, newValue);
  };

  return (
    <div className="dynamicFilter">
      <div className="dynamicFilterSelect">
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="filterType-label">Filter By</InputLabel>
          <Select
            labelId="filterType-label"
            id="filterType"
            value={filterType}
            onChange={handleFilterTypeChange}
          >
            {filters.map((f) => (
              <MenuItem key={f.key} value={f.key}>
                {f.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="dynamicFilterValue">
        <Autocomplete
          size="small"
          sx={{ m: 1, minWidth: 200 }}
          options={filterType ? Object.keys(values[filterType] ?? {}) : []}
          getOptionLabel={(option) => option}
          renderInput={(params) => (
            <TextField {...params} label="Select Value" />
          )}
          value={selectedOption}
          onChange={handleOptionChange}
          disabled={!filterType}
        />
      </div>
    </div>
  );
}

export default DynamicFilter